import { useEffect } from "react";
import type { ReactNode } from "react";
import { DEFAULT_PAGE_TITLE, routesConfig } from "app-config";
import { matchRoutes, useLocation } from "react-router";

const tempRoutes = Object.keys(routesConfig).map((v) => ({
  path: routesConfig[v as keyof typeof routesConfig].path,
  element: routesConfig[v as keyof typeof routesConfig].title,
}));

/** Ce composant change le title de la page selon le routing dans routesConfig */
function TitlesUtil(): ReactNode {
  const location = useLocation();

  useEffect(() => {
    const match = matchRoutes(tempRoutes, location);
    let title: string | undefined;
    if (match != null) {
      title = match[0]?.route?.element;
    }
    document.title = title ?? DEFAULT_PAGE_TITLE;
  }, [location]);

  return null;
}

export default TitlesUtil;
